import { Grid, makeStyles, Theme, createStyles, InputLabel, Select, MenuItem, Fab, FormControl } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import Main from '../../components/main';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { useEffect } from 'react';
import { getCompanies } from '../../services/companyServices';
import { CompanySearchModel, Company } from '../../models/company';
import { Applicazioni } from '../../types/types';
import { useHistory} from 'react-router-dom';
import 'react-dropzone-uploader/dist/styles.css'
import DownloadIcon from '@material-ui/icons/CloudDownload';
import { ClearIcon} from '../../icons/icons';
import { useLogger } from '../../logger';
import { motion } from 'framer-motion';
import { getDatiUtilizzo } from '../../services/reportService';
import { ExportDataSearchModel } from '../../models/exportData';
import { downloadCsv } from '../../utils/browser';
import { Label, SignalCellularNull } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) => createStyles({
    filterContainer: {
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(0),
        display: 'flex',
    },
    filterTitle: {
        flex: '0 1 auto', 
        // paddingTop: '12px'        
    },
    fab: {
        textAlign: 'right'
    },
    formControl: {
        marginTop: '4px',
        minWidth: 150
    },
    tableContainer: {
        width: "100%",
        marginTop: theme.spacing(3),
        overflowX: "auto",
    },
    table: {
        minWidth: 700,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
        // background: '#d5d4d9a8',
        borderRadius: '7px'
    },
}));
  
export default function ReportIndex() {
    const classes = useStyles();
    const gClasses = globalStyles();
    const [auth,] = useGlobal<IGlobalState, 'auth'>('auth')
    const[identity,] = useGlobal<IGlobalState, 'identity'>('identity');
    const[ip] = useGlobal<IGlobalState, 'ip'>('ip');
    const[companies, setCompanies] = useGlobal<IGlobalState, 'companies'>('companies');
    const[, setApplication] = useGlobal<IGlobalState, 'application'>('application');
    let title: string = 'Report dati utilizzo';
    const [globalWait, setGlobalWait]= useGlobal<IGlobalState, 'globalWait'>('globalWait');
    const [companyId, setCompanyId] = React.useState<number>();
    const [exportingReport, setExportingReport] = useGlobal<IGlobalState, 'exportingReport'>('exportingReport');
    const logger = useLogger({key: 'report'});
    let model: ExportDataSearchModel = new ExportDataSearchModel();
    
    const loadCompanies = async () => {
        let model = new CompanySearchModel();
        if (identity?.CompanyId) {
            console.log('identity ha una company');
            model.Id = identity?.CompanyId;
        }
        model.ImportEnabled = true;
        let companyList = await getCompanies(ip, auth.authData!, auth.user!, model);
        //console.log('Carico le Company: ' + companyList.length);
        setCompanies(companyList);
    }
        
    const handleChangeSelectCompany = (e: any) => {
        let { name, value } = e.target;
        setCompanyId(value);
    }
    
    const handleDownload = () => {
        if (companyId === 0 || !companyId) {
            logger.error('Company non impostata');
            return;
        }
        setExportingReport(true);
        setGlobalWait(true);
        model.companyId = companyId!;
        getDatiUtilizzo(ip, auth.authData!, auth.user!, model)
        .then((buffer: any) => { 
            //console.log('Download dati utilizzo ' + JSON.stringify(buffer));
            downloadCsv(buffer, 'DatiUtilizzo');
        })
        .catch(error => {logger.error('Errore in download dati utilizzo: ' + error.statusText); })
        .finally(() => {
            setExportingReport(false)
            setGlobalWait(false);
        });
    }
    
    useEffect(() => {
        loadCompanies();
        setApplication(Applicazioni.Report);
        //Pre imposto la Company
        if (identity?.CompanyId) {
            setCompanyId(identity?.CompanyId);
        }
    },[]);

    return (
      <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
        <IForfettariAppBar title="IForfetari" handleLoad={() => {}} handleChange={() =>{}}></IForfettariAppBar>
        <Main>
        <div className={gClasses.rootModel}>
            <motion.div
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                transition={{ delay: 0.5, duration: 1.5}}
                style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start',  flex: '0 1 auto'}}                    
            >
                <Grid container direction="column">
                    <Grid container >
                        <div className={classes.filterTitle}>
                            <h3>
                                Filtri
                            </h3>
                        </div>
                        &nbsp;
                        <Grid item lg={2} xs={12}>
                            <InputLabel htmlFor="company">Company</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={identity?.CompanyId ? identity?.CompanyId : companyId}
                                onChange={handleChangeSelectCompany}
                                inputProps={{
                                    name: 'company',
                                    id: 'companyId',
                                }}
                                >
                                {companies.map((item: Company, keyIndex: number) => {
                                    return (
                                    <MenuItem key={keyIndex.toString()} value={item.Id}>
                                        {item.BusinessName}
                                    </MenuItem>
                                    )                    
                                })
                                }
                            </Select>
                        </Grid>
                        {/* <div style={{ flex: '0 1 auto', paddingTop: '10px' }}>
                            <Fab color='default' size='small' className={classes.fab} title="Pulisci filtri"
                                onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleClear()}>
                                <ClearIcon />
                            </Fab>
                        </div> */}
                    </Grid>
                    <Grid container>
                        <div>
                            <br />
                        </div>
                    </Grid>
                    <Grid container>
                        <div>
                            <h1>
                                Analisi Utilizzo
                            </h1>
                        </div>
                        &nbsp;
                        <Grid item>
                            <div style={{ flex: '0 1', paddingTop: '10px' }}>
                                {/* <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleAdd()}><AddIcon /></Fab> */}
                                <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleDownload()}>
                                    <DownloadIcon titleAccess="Download analisi utilizzo"/>
                                </Fab>
                            </div>

                        </Grid>
                    </Grid>   
                </Grid>                 
            </motion.div> 
            {/*           
            <Paper className={classes.tableContainer}>
            <Table className={classes.table} size='small'>
                <TableHead>
                    <TableRow>
                        <CustomTableCell>Anno Dichiarativo</CustomTableCell>
                        <CustomTableCell>Codice Fiscale/P.Iva</CustomTableCell>
                        <CustomTableCell>Tipo telematico</CustomTableCell>
                        <CustomTableCell>Company</CustomTableCell>
                        <CustomTableCell>Studio</CustomTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {!loadingTelematico && filteredTelematico && filteredTelematico.length 
                    ? (filteredTelematico.slice(pagination.page * pagination.rowsPerPage, pagination.page * pagination.rowsPerPage + pagination.rowsPerPage).map(telamatico => (
                        <TableRow hover={true} key={telamatico.Id} className={classes.tablerow}>
                            <CustomTableCell>{telamatico.Year}</CustomTableCell>
                            <CustomTableCell>{telamatico.TaxCodeDichiarante}</CustomTableCell>
                            <CustomTableCell>{telamatico.TelematicoType}</CustomTableCell>
                            <CustomTableCell>{telamatico.DescCompany}</CustomTableCell>
                            <CustomTableCell>{telamatico.DescAgency}</CustomTableCell>
                        </TableRow>
                    ))) 
                    : <CustomTableRow>
                        <CustomTableCell colSpan={5}>
                            <Typography variant="h6" color="textSecondary">{loadingTelematico ? "Caricamento..." : "Nessun dato da visualizzare"}</Typography>
                        </CustomTableCell>
                    </CustomTableRow>
                }
                </TableBody>
                <TableFooter>
                    <CustomTableRow>
                        <CustomTableCell colSpan={6}>
                            <TablePagination
                                rowsPerPageOptions={[10,20,30]}
                                count={filteredTelematico ? filteredTelematico.length : 0}
                                rowsPerPage={pagination.rowsPerPage}
                                page={pagination.page}
                                SelectProps={{native: false,}}
                                onChangePage={_handleChangePage}
                                onChangeRowsPerPage={_handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                                labelRowsPerPage="Righe per pagina"
                                labelDisplayedRows={({ from, to, count }) => count ? `${from}-${to} di ${count}` : ""}
                                component='div'
                                style={{display: 'flex'}}
                            />
                        </CustomTableCell>
                    </CustomTableRow>
                </TableFooter>
            </Table>
            </Paper>
            */}
        </div>
        </Main>
      </div>
    );
}